import { render, staticRenderFns } from "./serviceSiteDialog.vue?vue&type=template&id=504df3e4&scoped=true&"
import script from "./serviceSiteDialog.vue?vue&type=script&lang=js&"
export * from "./serviceSiteDialog.vue?vue&type=script&lang=js&"
import style0 from "./serviceSiteDialog.vue?vue&type=style&index=0&id=504df3e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504df3e4",
  null
  
)

export default component.exports